// Load the tabs and images
const style = document.querySelectorAll('.sd-lp-tabs')[0].className.split(' ')[1]
if (style === 'style-1') {
  const tabs = document.querySelectorAll('.sd-lp-tab-text')
  // Loop through the tabs and add a click handler to each one
  tabs.forEach(tab => {
    tab.addEventListener('click', function (event) {
      // Get the id, active image,  and active tab
      const id = tab.getAttribute('tab_id')
      const activeImage = document.querySelector('.sd-lp-tabs-img.active')
      const activeTab = document.querySelector('.sd-lp-tab-text.active')

      // Remove the active class from the active tab and image
      activeTab.classList.remove('active')
      activeImage.classList.remove('active')

      // Get the associated image from the clicked tab
      const selectedImage = document.querySelector(`.${id}`)

      // Make sure that they're both displayed
      selectedImage.classList.add('active')
      this.classList.add('active')
    })
  })
} else if (style === 'style-2') {
  const tabs = document.querySelectorAll('.sd-lp-tabs-heading')
  // Loop through the tabs and add a click handler to each one
  tabs.forEach(tab => {
    tab.addEventListener('click', function (event) {
      // Get the id, active image,  and active tab
      const id = tab.getAttribute('tab_id')
      const activeHeading = document.querySelector('.sd-lp-tabs-heading.active')
      const activeTab = document.querySelector('.sd-lp-tab-text.active')

      // Remove the active class from the active tab and image
      activeHeading.classList.remove('active')
      activeTab.classList.remove('active')

      // Get the associated image from the clicked tab
      const selectedTab = document.querySelector(`.${id}`)

      // Make sure that they're both displayed
      selectedTab.classList.add('active')
      this.classList.add('active')
    })
  })
}
